import React from 'react';
import $ from 'jquery';
import { FaRegCopy } from 'react-icons/fa';
import CloseButton from '../../Buttons/CloseButton';
import { notification } from '../../../assets/constants/strings';

// One-time reveal of a newly created key + secret. The secret is never retrievable
// again, so this modal is the single place the user can copy it.
const SecretModal = ({ createdKey }) => {
  const copy = (value, label) => {
    if (!value) return;
    navigator.clipboard
      .writeText(value)
      .then(() => notification('success', `${label} copied to clipboard`))
      .catch(() => notification('info', 'Could not copy', 'Please copy manually.'));
  };

  const usage = createdKey
    ? `curl -H "X-Api-Key: ${createdKey.key}" \\\n     -H "X-Api-Secret: ${createdKey.secret}" \\\n     https://webapi.regulationcity.com/api/v1/Document/Get`
    : '';

  const Field = ({ label, value }) => (
    <div className='form-group mb-3'>
      <label className='font-weight-bold'>{label}</label>
      <div className='d-flex align-items-center'>
        <input className='form-control' readOnly value={value || ''} />
        <button
          type='button'
          className='copyBtn ml-2'
          title={`Copy ${label}`}
          onClick={() => copy(value, label)}
        >
          <FaRegCopy />
        </button>
      </div>
    </div>
  );

  return (
    <div
      className='modal'
      id='revealKeyModal'
      role='dialog'
      aria-hidden='true'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2 className='modal-title'>API key created</h2>
            <CloseButton
              title='Dismiss Modal'
              handleClose={() => $('#revealKeyModal').modal('hide')}
            />
          </div>
          <div className='modal-body'>
            <div className='alert alert-warning'>
              <b>Copy your secret now.</b> For security, we won’t show it again
              after you close this dialog.
            </div>
            {createdKey && createdKey.name && (
              <p className='mb-3'>
                Name: <b>{createdKey.name}</b>
              </p>
            )}
            <Field label='API key' value={createdKey && createdKey.key} />
            <Field label='Secret' value={createdKey && createdKey.secret} />

            {createdKey && (
              <div className='form-group mb-0'>
                <label className='font-weight-bold'>Use it</label>
                <p className='text-muted mb-2'>
                  Send the key and secret in the <code>X-Api-Key</code> and{' '}
                  <code>X-Api-Secret</code> headers:
                </p>
                <div className='d-flex align-items-start'>
                  <pre className='usageSnippet flex-grow-1 mb-0'>{usage}</pre>
                  <button
                    type='button'
                    className='wf-button wf-outline ml-2'
                    title='Copy example'
                    onClick={() => copy(usage, 'Example')}
                  >
                    <FaRegCopy />
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button
              className='wf-button'
              onClick={() => $('#revealKeyModal').modal('hide')}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecretModal;
